import {createAsyncThunk, createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import IprojectData from '../../interfaces/projectData.interface';
import Iphase from '../../interfaces/phase.Interface';

// Define a type for the slice state
export interface PhaseState {
    current_phase?:Iphase
}

// Define the initial state using that type
const initialState: PhaseState = {
    current_phase: undefined
}




export const PhaseSlice = createSlice({
  name: 'Phases',
  initialState,
  reducers: {
    setActivePhase: (state, {payload}:PayloadAction<Iphase>)=>{
        if(payload.id){
            state.current_phase = payload;
        }else{
            state.current_phase = undefined;
        }
    }
    
  },
  extraReducers: (builder) => {
    
  }
});
    

export const {setActivePhase} = PhaseSlice.actions


export default PhaseSlice.reducer